import { useLanguage } from "../i18n/LanguageContext";
import { Reveal, Overline } from "./Reveal";
import { ServiceIcon } from "./Icons";

const EquipmentSection = () => {
    const { t } = useLanguage();
    return (
        <section id="equipment" className="scroll-mt-24 py-12 md:py-20" aria-labelledby="equipment-title" data-testid="equipment-section">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <Reveal className="max-w-2xl">
                    <Overline>{t.equipment.overline}</Overline>
                    <h2 id="equipment-title" className="mt-4 font-display text-3xl font-bold tracking-tight text-ink sm:text-4xl lg:text-5xl">
                        {t.equipment.title}
                    </h2>
                    <p className="mt-4 text-base leading-relaxed text-mist md:text-lg">{t.equipment.subtitle}</p>
                </Reveal>
                <div className="mt-10 grid gap-4 sm:grid-cols-2 md:gap-6 lg:grid-cols-3">
                    {t.equipment.items.map((item, i) => (
                        <Reveal key={item.name} delay={Math.min(i * 0.05, 0.3)} className="h-full">
                            <article
                                data-testid={`equipment-card-${i + 1}`}
                                className="group flex h-full items-start gap-4 rounded-2xl border border-ink/10 bg-surface p-6 shadow-sm transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1 hover:border-gold-500/50 hover:shadow-[0_24px_45px_-25px_rgba(0,77,77,0.4)]"
                            >
                                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-gold-100 text-gold-600 transition-[transform,background-color,color] duration-300 group-hover:scale-110 group-hover:bg-gold-500 group-hover:text-ink">
                                    <ServiceIcon name={item.icon} />
                                </span>
                                <span>
                                    <h3 className="text-base font-bold text-ink">{item.name}</h3>
                                    <p className="mt-1.5 text-sm leading-relaxed text-mist">{item.desc}</p>
                                </span>
                            </article>
                        </Reveal>
                    ))}
                </div>
                <Reveal delay={0.15} className="mt-10">
                    <a
                        href="#appointment"
                        data-testid="equipment-book-cta"
                        className="inline-flex min-h-[48px] items-center rounded-full bg-pine px-7 text-sm font-semibold text-cream transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-pine-600 active:scale-95"
                    >
                        {t.ctas.book}
                    </a>
                </Reveal>
            </div>
        </section>
    );
};

export default EquipmentSection;
